
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

/**
 *  Factory with methods for create de dynamic menu and submenu.
 *
 * @param {any} $rootScope
 * @param {any} userAccessConstant
 * @param {any} navigationConstant
 * @returns
 */
function headerFactory($rootScope, userAccessConstant, navigationConstant) {
	'ngInject';

	return {
		createMenuByProfile: createMenuByProfile
	};

	/**
	 * Create dynamic menu with pages with the pages associated with the auth user.
	 *
	 * @param {any} profile
	 */
	function createMenuByProfile(profile) {
		$rootScope.menuItems = [];
		$rootScope.submenus = [];

		const codesMenu = userAccessConstant[profile].MENUS;

		for (let codeMenu of codesMenu) {
			const menu = _.findLast(navigationConstant.RESOURCES, menuNav => menuNav.CODE === codeMenu);
			if (menu) {
				$rootScope.menuItems.push(menu);
				if (menu.SUBMENUS) {
					createSubmenuList($rootScope.submenus, menu, userAccessConstant[profile].SUBMENUS);
				}
			}
		}
	}

	/**
	 * Create dynamic submenu with pages with the pages associated with the auth user.
	 *
	 * @param {any} submenus
	 * @param {any} menu
	 * @param {any} submenuItems
	 */
	function createSubmenuList(submenus, menu, submenuItems) {

		let submenuElements = [];
		for (let submenuAccess of submenuItems) {
			const submenu = _.findLast(menu.SUBMENUS, submenuNav => submenuNav.CODE === submenuAccess);

			if (submenu) {
				submenuElements.push(submenu);
			}
		}

		submenus.push({
			menuCode: menu.CODE,
			submenus: submenuElements
		});
	}
}

export default headerFactory;



// WEBPACK FOOTER //
// ./src/app/core/components/header/header.factory.js